import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatInTimeZone } from 'date-fns-tz'
import { Box, Text, TextLink } from '@machobear/design-system'
import { getEditMlsListingLink } from '@/utils/getEditMlsListingLink'
import { useListingData } from '../../context/listing-data'

export const IntegrationDetails = () => {
  const { t } = useTranslation()

  const {
    externalInfo,
    createdAt = '',
    lastUpdatedAt = '',
    sourceName = '',
    sourceAbbreviation = ''
  } = useListingData()

  const realtorName = externalInfo?.realtor_name ?? ''

  const { link = '' } = getEditMlsListingLink(externalInfo)
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()

  const formattedLastUpdatedAt = formatInTimeZone(
    `${lastUpdatedAt || createdAt} UTC`,
    timeZone,
    'MMMM d, yyyy h:mm a zzz'
  )

  return (
    <Box borderRadius="large" display="flex" flexDirection="column" gap="gutter">
      <Text weight="strong">{t('Imported from MLS®')}</Text>

      <Box display="flex" flexDirection="column" gap="small">
        <Text weight="medium" size="small" tone="tertiary">
          {t('Realtor')}
        </Text>
        <TextLink href={link} target="_blank">
          {realtorName}
        </TextLink>
      </Box>

      <Box display="flex" flexDirection="column" gap="small">
        <Text weight="medium" size="small" tone="tertiary">
          {t('l.listing.integration_details.source.label.text', 'Source')}
        </Text>
        <Text tone="secondary" weight="medium">
          {sourceName} ({sourceAbbreviation})
        </Text>
      </Box>

      <Box display="flex" flexDirection="column" gap="small">
        <Text size="small" tone="tertiary">
          {t('l.listing.integration_details.last_updated.text', ' Listing last updated on')}{' '}
        </Text>
        <Text tone="secondary" weight="medium">
          {formattedLastUpdatedAt}
        </Text>
      </Box>
    </Box>
  )
}
